// import { Dispatch, Action } from 'redux'

import { HistoryListMapDispatchReturnType } from './types'

export const HistoryListMapDispatch = (): // dispatch: Dispatch<Action>
HistoryListMapDispatchReturnType => {
  return {}
}
